import { useGlobalState } from "../../../state/hooks/useGlobalState";
import { useBackendAPIRequest } from "../useBackendAPIRequest";
import {
    isValidWarningLayerDataResponse,
    mapApiWarningLayerDataToWarningLayerData,
} from "./mapper";
import type { ApiWarningLayerData } from "./types/api";
import type { WarningLayerData } from "./types/data";

export function useWarningLayerData(skipRequest = false) {
    const { activeWorldRegion } = useGlobalState();

    let url;

    switch (activeWorldRegion) {
        case "eu":
            url = `/maps/warnings/tiles/EU`;
            break;

        case "us":
            // TODO: we don't support warnings for US yet
            break;
    }

    return useBackendAPIRequest<
        ApiWarningLayerData,
        WarningLayerData | undefined
    >(
        url,
        (responseJson) => {
            if (!isValidWarningLayerDataResponse(responseJson)) {
                return undefined;
            }

            return mapApiWarningLayerDataToWarningLayerData(
                responseJson,
                activeWorldRegion,
            );
        },
        { skip: skipRequest || url === undefined },
    );
}
